export enum ArrowButtonDirection {
  Left = 'left',
  Right = 'Right',
}

export enum ArrowButtonSize {
  Large = 'large',
  Small = 'small',
}
